/**
 * Created by rhinov12 on 01/12/2015.
 */
/**
 * Custom node for walls
 */

import { EntityNode } from "./EntityNode";
import { DimensionNode } from "../Nodes/DimensionNode";
import { ActionStateEnum } from "../../state/actionState/ActionState";
import { GameObjectManager } from "../GameObjectManager";
import { EntityManager } from "../EntityManager";
import { Utils } from "../../utils/Utils";
import { CocosConstants } from "../../../../constants";
import { PlanManager } from "../../../../cocosPlan";
import { Coating, ComponentConstants, Events, eventsManager, math, SavaneConstants, SceneConstants, Wall, wallManager } from "@rhinov/savane-js";

declare var cc: any;

export class WallNode extends EntityNode {

    savaneEntity: Wall;
    constructor(wall: Wall) {
        super(wall);
        this.savaneEntity = wall;
        // To store the wall savane entity that created this wall node
        this.wallEntity = wall;
        this.wallId = wall.id;
        //Wall state
        //this._selected = false;
        this._valid = true;
        //this._hover = false;
        this._cuttingWall = null;
        this._forcedDimensions = false;
        this._showDimensionChecked = PlanManager.getInstance().showDimension;
        //Init wall
        //  this.init();
        this.dimWall = { x: 1, y: 1 };

        // Dimensions
        this.wallDimTop = null;
        this.wallDimBot = null;
        // Border dimensions
        this.wallDimLeftBot = null;
        this.wallDimRightBot = null;
        this.wallDimLeftTop = null;
        this.wallDimRightTop = null;
        // Hover display
        this.topSprite = null;
        this.botSprite = null;
        this.middleSprite = null;

        this.dotVisible = true;

        this.transparentDraw = PlanManager.getInstance()._wallWireframe;

        this.isOnCurrentFloor = true;
        // It happens sometimes that want to display a wall with no parent foor. Reason is unknown so protection to avoid a crash here.
        if (this.wallEntity.floor.id !== PlanManager.getInstance().world.currentScene!.currentFloor!.id) {
            this.isOnCurrentFloor = false;
        }

        // If a wallNode is created in idleVisualisation, then no need to display dots they aren't displayed
        if (PlanManager.getInstance()._state.getAction() === ActionStateEnum.idleVisualise) {
            this.dotVisible = false;
        }

        this.baseColor = '#555b62';

        if (!this.isOnCurrentFloor) {
            //This floor is display as an under floor
            this.baseColor = '#C8CACC';
            this.dotVisible = false;
            this.editable = false;
            //this.setLocalZOrder(-1);
        } else {
            this.editable = true;
        }
        //Coatings
        this.tempCoatingDirect = null;
        this.tempCoatingUndirect = null;
        //Movable state
        this._movableUIActive = false;
        //Create dimensions nodes
        this.createWallDimension();

        //DEBUG NODE WITH WALL ID
        /*if (this.wallEntity.floor.id === PlanManager.getInstance().world.currentScene!.currentFloor!.id) {
            this.wallIdLabel = new cc.LabelTTF('' + this.wallId, 'Roboto-Light', 16, new cc.size(0, 20), cc.TEXT_ALIGNMENT_CENTER, cc.TEXT_ALIGNMENT_CENTER);
            this.wallIdLabel.setName('TopLabel');
            this.wallIdLabel.setPosition(this.wallEntity.length / 20, this.dimWall.y * 0.5 + (this.wallEntity.thickness + this.savaneEntity.shiftOffset) / 10);
            this.wallIdLabel.setFontFillColor(new cc.color(255, 0, 0, 255));
            this.wallIdLabel.zIndex = 999999;
            this.addChild(this.wallIdLabel);
        }*/
        //FIXME DIRTY
        this.arrWallListBot = [];
        this.arrWallListTop = [];
        this.arrOnWallListener = eventsManager.instance.addListener('attach_item_to_wall', (event: any) => {
            var data = event.userData;
            if (data.arrangement.objectType === SceneConstants.ArrangementType.kitchenFurnitureTop) {
                var indexInList = this.arrWallListTop.indexOf(data.arrangement);
                if (data.wall !== this.savaneEntity.id && indexInList >= 0) {
                    //Remove from list
                    this.arrWallListTop.splice(indexInList, 1);
                } else if (data.wall === this.savaneEntity.id && indexInList < 0) {
                    this.arrWallListTop.push(data.arrangement);
                }
            } else if (data.arrangement.isSnappableBottomArrangement() || data.arrangement.isSnappableColumnArrangement()) {
                var indexInList = this.arrWallListBot.indexOf(data.arrangement);
                if (data.wall !== this.savaneEntity.id && indexInList >= 0) {
                    //Remove from list
                    this.arrWallListBot.splice(indexInList, 1);
                } else if (data.wall === this.savaneEntity.id && indexInList < 0) {
                    this.arrWallListBot.push(data.arrangement);
                }
            }

        });

        this.setWallTransparency = eventsManager.instance.addListener(Events.WALL_SET_TRANSPARENCY, (_event: any) => {
            this.needRedraw = true;
            this.transparentDraw = PlanManager.getInstance()._wallWireframe;
        });

        this.needRedraw = true;
        this.update();
    }

    createArea(_area: any) {
    }

    removeArea() {
    }

    setClosed(_value: boolean) {
    }

    setPointSelected(_value: boolean) {
    }

    setLineSelected(_value: boolean) {
    }

    drawWall(box: any) {
        this.clear();
        //Compensate using the transform
        var _matrix = this.savaneEntity.transform.invertedGlobalMatrix;
        var vertex = [];
        for (var i = 0; i < box.length; i++) {
            math.vec3.transformMat4(box[i], box[i], _matrix);
            if (i === 1) {
                vertex.push(new cc.p(0, 0));
            }
            else if (i === 3) {
                vertex.push(new cc.p(this.savaneEntity.length / 10, 0));
            }
            vertex.push(GameObjectManager.convertToCocosCoord(box[i]));
        }
        //Border size
        var borderThickness = 0.9 / PlanManager.getInstance().getZoomScale();

        //Draw poly
        var yellow = new cc.color('#F5D231');
        var grey = new cc.color(this.baseColor);
        var red = new cc.color('#FF7D8D');

        if (!this.isOnCurrentFloor) {
            grey.a = PlanManager.getInstance().opacityFloors;
        }
        else {
            if (PlanManager.getInstance().highlightMode) {
                grey.a = 90;
                yellow.a = 90;
                red.a = 90;
            }

            if (this.wallEntity.height <= 1000) {
                grey.a = 160;
                yellow.a = 160;
                red.a = 160;
            }

            if (this.wallEntity.height === 0) {
                grey.a = 32;
                yellow.a = 64;
                red.a = 64;
            }
        }
        var color = this._valid ? (this._isSelected ? yellow : grey) : red;
        var colorInside = new cc.color(color);

        if (this.transparentDraw && this.isOnCurrentFloor) {
            colorInside.a = 16;
        }

        this.drawPoly(vertex, colorInside, borderThickness, color);

        // Special walls management for instance for balcony rails
        if (this.wallEntity.isSpecialWall) {
            var white = new cc.color('#FFFFFF');

            var specialWallThickness = (this.wallEntity.thickness / 2) / 10;
            var specialWallVertex = [];
            var wallBoundingBox = [];

            wallBoundingBox.push([this.savaneEntity.begin[0] + this.savaneEntity.wallDirection[1] * (specialWallThickness - this.savaneEntity.shiftOffset),
            this.savaneEntity.begin[1] + this.savaneEntity.wallDirection[0] * (-specialWallThickness + this.savaneEntity.shiftOffset),
                0]);
            wallBoundingBox.push([this.savaneEntity.begin[0] + this.savaneEntity.wallDirection[1] * (-specialWallThickness - this.savaneEntity.shiftOffset),
            this.savaneEntity.begin[1] + this.savaneEntity.wallDirection[0] * (specialWallThickness + this.savaneEntity.shiftOffset),
                0]);
            wallBoundingBox.push([this.savaneEntity.end[0] + this.savaneEntity.wallDirection[1] * (-specialWallThickness - this.savaneEntity.shiftOffset),
            this.savaneEntity.end[1] + this.savaneEntity.wallDirection[0] * (specialWallThickness + this.savaneEntity.shiftOffset),
                0]);
            wallBoundingBox.push([this.savaneEntity.end[0] + this.savaneEntity.wallDirection[1] * (specialWallThickness - this.savaneEntity.shiftOffset),
            this.savaneEntity.end[1] + this.savaneEntity.wallDirection[0] * (-specialWallThickness + this.savaneEntity.shiftOffset),
                0]);

            for (i = 0; i < wallBoundingBox.length; ++i) {
                math.vec3.transformMat4(wallBoundingBox[i], wallBoundingBox[i], this.savaneEntity.transform.invertedGlobalMatrix);

                specialWallVertex.push(new cc.p(wallBoundingBox[i][0] / 10, wallBoundingBox[i][1] / 10));
            }

            this.drawPoly(specialWallVertex, color, specialWallThickness, white);
        }

        // Afficher les coating seulement si ce mur est à l'étage courant
        if (this.isOnCurrentFloor) {
            //Draw coatings
            var va = [];
            var vb = [];
            for (i = 0; i < vertex.length; i++) {
                switch (i) {
                    case 0:
                        va.push(vertex[i]);
                        break;
                    case 1:
                        va.push(vertex[i]);
                        vb.push(vertex[i]);
                        break;
                    case 2:
                        vb.push(vertex[i]);
                        break;
                    case 3:
                        vb.push(vertex[i]);
                        break;
                    case 4:
                        vb.push(vertex[i]);
                        va.push(vertex[i]);
                        break;
                    case 5:
                        va.push(vertex[i]);
                        break;
                }
            }
            //Generate coating
            var coatings = this.savaneEntity.getComponents(ComponentConstants.ComponentType.Coating) as Coating[];
            var coatingColor;
            for (i = 0; i < coatings.length; i++) {
                if (coatings[i].hangType === Coating.HangType.wallDirect && this.tempCoatingDirect === null) {
                    if (coatings[i].colors[0] && coatings[i].colors[0].realColor !== undefined) {
                        coatingColor = new cc.color(coatings[i].colors[0].realColor);
                    }
                    else {
                        coatingColor = new cc.color(255, 0, 255);
                    }
                    coatingColor.a = 180;
                    this.drawPoly(vb, coatingColor, borderThickness, coatingColor);

                    if (this.wallEntity.isSpecialWall) {
                        this.drawPoly(va, coatingColor, borderThickness, coatingColor);
                    }
                }
                if (coatings[i].hangType === Coating.HangType.wallUndirect && this.tempCoatingUndirect === null) {
                    if (coatings[i].colors[0] && coatings[i].colors[0].realColor !== undefined) {
                        coatingColor = new cc.color(coatings[i].colors[0].realColor);
                    }
                    else {
                        if (coatings[i].color) {
                            coatingColor = new cc.color(coatings[i].color.color);
                        }
                        else {
                            if (coatings[i].colors[0] !== undefined && coatings[i].colors[0].color !== undefined && coatings[i].colors[0].color !== null) {
                                coatingColor = new cc.color(coatings[i].colors[0].color.color);
                            }
                            else {
                                coatingColor = new cc.color(255, 0, 255);
                            }
                        }
                    }
                    coatingColor.a = 180;
                    this.drawPoly(va, coatingColor, borderThickness, coatingColor);

                    if (this.wallEntity.isSpecialWall) {
                        this.drawPoly(vb, coatingColor, borderThickness, coatingColor);
                    }
                }
            }
            if (this.tempCoatingUndirect !== null) {
                coatingColor = new cc.color(this.tempCoatingUndirect);
                coatingColor.a = 180;
                this.drawPoly(va, coatingColor, borderThickness, coatingColor);

                if (this.wallEntity.isSpecialWall) {
                    this.drawPoly(vb, coatingColor, borderThickness, coatingColor);
                }
            }
            if (this.tempCoatingDirect !== null) {
                coatingColor = new cc.color(this.tempCoatingDirect);
                coatingColor.a = 180;
                this.drawPoly(vb, coatingColor, borderThickness, coatingColor);

                if (this.wallEntity.isSpecialWall) {
                    this.drawPoly(va, coatingColor, borderThickness, coatingColor);
                }
            }
        }

        // Display of wall slopes
        if (this.wallEntity.slope) {
            var yellow = new cc.color('#F5D231');
            yellow.a = 90;
            var length = this.savaneEntity.length / 25;
            var wallDirection0Length = this.savaneEntity.wallDirection[0] * length;
            var wallDirection1Length = this.savaneEntity.wallDirection[1] * length;
            var wallBeginDirection0Length = this.savaneEntity.begin[0] + wallDirection0Length;
            var wallBeginDirection1Length = this.savaneEntity.begin[1] + wallDirection1Length;
            var wallEndDirection0Length = this.savaneEntity.end[0] - wallDirection0Length;
            var wallEndDirection1Length = this.savaneEntity.end[1] - wallDirection1Length;

            var wallDirection0ShiftOffset;
            var wallDirection1ShiftOffset;

            var slopeVertex = [];
            var slopeBoundingBox = [];

            if (this.savaneEntity.slopeLength1 !== 0) {
                var wallDirection1SlopeLengthShiftOffset = this.savaneEntity.wallDirection[1] * (this.savaneEntity.slopeLength1 + this.savaneEntity.shiftOffset + (this.savaneEntity.thickness / 2));
                var wallDirection0SlopeLengthShiftOffset = this.savaneEntity.wallDirection[0] * -(this.savaneEntity.slopeLength1 + this.savaneEntity.shiftOffset + (this.savaneEntity.thickness / 2));

                wallDirection0ShiftOffset = this.savaneEntity.wallDirection[0] * (this.savaneEntity.shiftOffset) - this.savaneEntity.wallDirection[0] * (this.savaneEntity.thickness / 2);
                wallDirection1ShiftOffset = this.savaneEntity.wallDirection[1] * -(this.savaneEntity.shiftOffset) - this.savaneEntity.wallDirection[1] * -(this.savaneEntity.thickness / 2);

                slopeBoundingBox.push([wallBeginDirection0Length + wallDirection1ShiftOffset,
                wallBeginDirection1Length + wallDirection0ShiftOffset,
                    0]);
                slopeBoundingBox.push([wallBeginDirection0Length + wallDirection1SlopeLengthShiftOffset,
                wallBeginDirection1Length + wallDirection0SlopeLengthShiftOffset,
                    0]);
                slopeBoundingBox.push([wallEndDirection0Length + wallDirection1SlopeLengthShiftOffset,
                wallEndDirection1Length + wallDirection0SlopeLengthShiftOffset,
                    0]);
                slopeBoundingBox.push([wallEndDirection0Length + wallDirection1ShiftOffset,
                wallEndDirection1Length + wallDirection0ShiftOffset,
                    0]);

                for (i = 0; i < slopeBoundingBox.length; ++i) {
                    math.vec3.transformMat4(slopeBoundingBox[i], slopeBoundingBox[i], this.savaneEntity.transform.invertedGlobalMatrix);

                    slopeVertex.push(new cc.p(slopeBoundingBox[i][0] / 10, slopeBoundingBox[i][1] / 10));
                }

                this.drawPoly(slopeVertex, yellow, 1, grey);
            }

            if (this.savaneEntity.slopeLength2 !== 0) {
                slopeVertex = [];
                slopeBoundingBox = [];

                var wallDirection1SlopeLengthShiftOffset = this.savaneEntity.wallDirection[1] * -(this.savaneEntity.slopeLength2 - this.savaneEntity.shiftOffset + (this.savaneEntity.thickness / 2));
                var wallDirection0SlopeLengthShiftOffset = this.savaneEntity.wallDirection[0] * (this.savaneEntity.slopeLength2 - this.savaneEntity.shiftOffset + (this.savaneEntity.thickness / 2));

                wallDirection0ShiftOffset = this.savaneEntity.wallDirection[0] * (this.savaneEntity.shiftOffset) + this.savaneEntity.wallDirection[0] * (this.savaneEntity.thickness / 2);
                wallDirection1ShiftOffset = this.savaneEntity.wallDirection[1] * -(this.savaneEntity.shiftOffset) + this.savaneEntity.wallDirection[1] * -(this.savaneEntity.thickness / 2);

                slopeBoundingBox.push([wallBeginDirection0Length + wallDirection1ShiftOffset,
                wallBeginDirection1Length + wallDirection0ShiftOffset,
                    0]);
                slopeBoundingBox.push([wallBeginDirection0Length + wallDirection1SlopeLengthShiftOffset,
                wallBeginDirection1Length + wallDirection0SlopeLengthShiftOffset,
                    0]);
                slopeBoundingBox.push([wallEndDirection0Length + wallDirection1SlopeLengthShiftOffset,
                wallEndDirection1Length + wallDirection0SlopeLengthShiftOffset,
                    0]);
                slopeBoundingBox.push([wallEndDirection0Length + wallDirection1ShiftOffset,
                wallEndDirection1Length + wallDirection0ShiftOffset,
                    0]);

                for (i = 0; i < slopeBoundingBox.length; ++i) {
                    math.vec3.transformMat4(slopeBoundingBox[i], slopeBoundingBox[i], this.savaneEntity.transform.invertedGlobalMatrix);

                    slopeVertex.push(new cc.p(slopeBoundingBox[i][0] / 10, slopeBoundingBox[i][1] / 10));
                }

                this.drawPoly(slopeVertex, yellow, 1, grey);
            }
        }

        //DEBUG
        /*this.drawCircle(new cc.p(0,0), 10, Math.PI * 2, 100, false, 3, new cc.color(DEBUG_ENTITY_COLOR[this.savaneEntity.entityType]));
        this.drawCircle(new cc.p(0,0), 10, Math.PI * 2, 100, false, 3, new cc.color(DEBUG_ENTITY_COLOR[this.savaneEntity.entityType]));
        this.drawCircle(new cc.p(this.savaneEntity.length/10,0), 10, Math.PI * 2, 100, false, 3, new cc.color(DEBUG_ENTITY_COLOR[this.savaneEntity.entityType]));*/
        this.updateToArrangementDimensions(vertex);
    }

    drawOverlay(_localBox = null) {
        //Colors
        var yellow = new cc.color('#F5D231');
        var grey = new cc.color(this.baseColor);
        //thickness
        var hooverThickness = 20;
        if (!this.editable) {
            //This wall is not editable and wil be displayed behind scene
            //this.setLocalZOrder(-1);
        }
        else if (this._isHovered) {
            //this.setLocalZOrder(4.1);
            var hooverVertex = [];
            var wallBoundingBox = [];

            wallBoundingBox.push([this.savaneEntity.begin[0] + this.savaneEntity.wallDirection[1] * (hooverThickness - this.savaneEntity.shiftOffset),
            this.savaneEntity.begin[1] + this.savaneEntity.wallDirection[0] * (-hooverThickness + this.savaneEntity.shiftOffset),
                0]);
            wallBoundingBox.push([this.savaneEntity.begin[0] + this.savaneEntity.wallDirection[1] * (-hooverThickness - this.savaneEntity.shiftOffset),
            this.savaneEntity.begin[1] + this.savaneEntity.wallDirection[0] * (hooverThickness + this.savaneEntity.shiftOffset),
                0]);
            wallBoundingBox.push([this.savaneEntity.end[0] + this.savaneEntity.wallDirection[1] * (-hooverThickness - this.savaneEntity.shiftOffset),
            this.savaneEntity.end[1] + this.savaneEntity.wallDirection[0] * (hooverThickness + this.savaneEntity.shiftOffset),
                0]);
            wallBoundingBox.push([this.savaneEntity.end[0] + this.savaneEntity.wallDirection[1] * (hooverThickness - this.savaneEntity.shiftOffset),
            this.savaneEntity.end[1] + this.savaneEntity.wallDirection[0] * (-hooverThickness + this.savaneEntity.shiftOffset),
                0]);

            for (var i = 0; i < wallBoundingBox.length; ++i) {
                math.vec3.transformMat4(wallBoundingBox[i], wallBoundingBox[i], this.savaneEntity.transform.invertedGlobalMatrix);
                if (i === 1) {
                    hooverVertex.push(new cc.p(0, this.savaneEntity.shiftOffset / 10));
                } else if (i === 3) {
                    hooverVertex.push(new cc.p(this.savaneEntity.length / 10, this.savaneEntity.shiftOffset / 10));
                }
                hooverVertex.push(new cc.p(wallBoundingBox[i][0] / 10, wallBoundingBox[i][1] / 10));
            }

            var borderThickness = 1;
            if (borderThickness * PlanManager.getInstance().getZoomScale() < 1 || borderThickness * PlanManager.getInstance().getZoomScale() > 1) {
                borderThickness /= PlanManager.getInstance().getZoomScale();
            }
            this.drawPoly(hooverVertex, yellow, borderThickness, yellow);
        } /*else {
          this.setLocalZOrder(4);
      }*/
        if (this.topSprite !== null) {
            this.topSprite.setPositionY((this.dimWall.y * 0.8) + (this.savaneEntity.shiftOffset / 10) + Utils.DIMENSION_DIST / PlanManager.getInstance().getZoomScale());
            this.topSprite.setVisible(true);
            if (this.savaneEntity.locked) {
                this.topSprite.setVisible(false);
            }
        }
        if (this.botSprite !== null) {
            this.botSprite.setPositionY((-this.dimWall.y * 0.8) + (this.savaneEntity.shiftOffset / 10) - Utils.DIMENSION_DIST / PlanManager.getInstance().getZoomScale());
            this.botSprite.setVisible(true);
            if (this.savaneEntity.locked) {
                this.botSprite.setVisible(false);
            }
        }
        if (this.middleSprite !== null) {
            this.middleSprite.setScaleX((this.dimWall.y * 2 * 0.8) + (this.savaneEntity.shiftOffset / 10));
            this.middleSprite.setVisible(true);
            if (this.savaneEntity.locked) {
                this.middleSprite.setVisible(false);
            }
        }

        //Draw dots if visibles
        if (this.dotVisible) {
            if (this.savaneEntity.locked && (this._isSelected || this._isHovered)) {
                yellow = new cc.color(255, 125, 141, 255)
            }
            var radius = 5;
            this.drawDot(new cc.p(0, 0), radius + 2, grey);
            this.drawDot(new cc.p(0, 0), radius, yellow);
            this.drawDot(new cc.p(this.savaneEntity.length / 10, 0), radius + 2, grey);
            this.drawDot(new cc.p(this.savaneEntity.length / 10, 0), radius, yellow);
            //DEBUG
            //this.drawDot(new cc.p(this.savaneEntity.length / 10, 0), radius, new cc.color(255, 0, 0, 255));
        }
    }
    updateToArrangementDimensions(box: any) {
        //BOT LINE
        if (CocosConstants.sketchMode && this.arrWallListBot.length > 0) {
            var angle = this.savaneEntity.getWallAngle(true) * 360.0 / (Math.PI * 2.0);
            if (this.wallDimLeftBot === null) {
                this.wallDimLeftBot = new DimensionNode(new cc.Color(200, 85, 100));
                this.wallDimLeftBot.setName('wallDimLeft' + this.wallId);
                this.addChild(this.wallDimLeftBot, 1);
            }
            if (this.wallDimRightBot === null) {
                this.wallDimRightBot = new DimensionNode(new cc.Color(200, 85, 100));
                this.wallDimRightBot.setName('wallDimLeft' + this.wallId);
                this.addChild(this.wallDimRightBot, 1);
            }
            //Calculate extrem left value from list
            var extremLeftPoint = null;
            var leftIsUp = false;
            var extremRightPoint = null;
            var rightIsUp = false;

            for (var i = 0; i < this.arrWallListBot.length; i++) {
                var arr = this.arrWallListBot[i];
                //Convert position to wall
                var localPosition = math.vec3.create();
                math.vec3.transformMat4(localPosition, arr.transform.globalPosition, this.savaneEntity.transform.invertedGlobalMatrix);
                var extremLeft = (localPosition[0] + arr.length * 0.5) / 10;
                var extremRight = (localPosition[0] - arr.length * 0.5) / 10;
                if (extremLeftPoint === null || extremLeft > extremLeftPoint) {
                    extremLeftPoint = extremLeft;
                    leftIsUp = localPosition[1] > 0;
                }
                if (extremRightPoint === null || extremRight < extremRightPoint) {
                    extremRightPoint = extremRight;
                    rightIsUp = localPosition[1] > 0;
                }
            }
            var cocosLength = this.savaneEntity.length / 10;
            var valueLeft = (cocosLength - extremLeftPoint!) - (cocosLength - (leftIsUp ? box[5].x : box[3].x));
            var valueRight = extremRightPoint! - (rightIsUp ? box[0].x : box[2].x);

            var decal = (this.savaneEntity.thickness / 20) + 30;

            this.wallDimLeftBot.setPosition(extremLeftPoint! + valueLeft / 2, leftIsUp ? -decal : decal);
            this.wallDimRightBot.setPosition(extremRightPoint! - valueRight / 2, rightIsUp ? -decal : decal);
            this.wallDimLeftBot.setDimensionValue(valueLeft, PlanManager.getInstance().getZoomScale());
            this.wallDimLeftBot.setFlipped(angle > 90 && angle <= 270 || (angle < -90 && angle >= -270));
            this.wallDimRightBot.setDimensionValue(valueRight, PlanManager.getInstance().getZoomScale());
            this.wallDimRightBot.setFlipped(angle > 90 && angle <= 270 || (angle < -90 && angle >= -270));
        } else {
            if (this.wallDimLeftBot !== null) {
                this.wallDimLeftBot.removeFromParent(true);
                this.wallDimLeftBot = null;
            }
            if (this.wallDimRightBot !== null) {
                this.wallDimRightBot.removeFromParent(true);
                this.wallDimRightBot = null;

            }
        }
        //TOP LINE
        if (CocosConstants.sketchMode && this.arrWallListTop.length > 0) {
            var angle = this.savaneEntity.getWallAngle(true) * 360.0 / (Math.PI * 2.0);
            if (this.wallDimLeftTop === null) {
                this.wallDimLeftTop = new DimensionNode(new cc.Color(70, 85, 200));
                this.wallDimLeftTop.setName('wallDimLeft' + this.wallId);
                this.addChild(this.wallDimLeftTop, 1);
            }
            if (this.wallDimRightTop === null) {
                this.wallDimRightTop = new DimensionNode(new cc.Color(70, 85, 200));
                this.wallDimRightTop.setName('wallDimLeft' + this.wallId);
                this.addChild(this.wallDimRightTop, 1);
            }
            //Calculate extrem left value from list
            var extremLeftPoint = null;
            var leftIsUp = false;
            var extremRightPoint = null;
            var rightIsUp = false;

            for (var i = 0; i < this.arrWallListTop.length; i++) {
                var arr = this.arrWallListTop[i];
                //Convert position to wall
                var localPosition = math.vec3.create();
                math.vec3.transformMat4(localPosition, arr.transform.globalPosition, this.savaneEntity.transform.invertedGlobalMatrix);
                var extremLeft = (localPosition[0] + arr.length * 0.5) / 10;
                var extremRight = (localPosition[0] - arr.length * 0.5) / 10;
                if (extremLeftPoint === null || extremLeft > extremLeftPoint) {
                    extremLeftPoint = extremLeft;
                    leftIsUp = localPosition[1] > 0;
                }
                if (extremRightPoint === null || extremRight < extremRightPoint) {
                    extremRightPoint = extremRight;
                    rightIsUp = localPosition[1] > 0;
                }
            }
            var cocosLength = this.savaneEntity.length / 10;
            var valueLeft = (cocosLength - extremLeftPoint!) - (cocosLength - (leftIsUp ? box[5].x : box[3].x));
            var valueRight = extremRightPoint! - (rightIsUp ? box[0].x : box[2].x);

            var decal = (this.savaneEntity.thickness / 20) + 45;

            this.wallDimLeftTop.setPosition(extremLeftPoint! + valueLeft / 2, leftIsUp ? -decal : decal);
            this.wallDimRightTop.setPosition(extremRightPoint! - valueRight / 2, rightIsUp ? -decal : decal);
            this.wallDimLeftTop.setDimensionValue(valueLeft, PlanManager.getInstance().getZoomScale());
            this.wallDimLeftTop.setFlipped(angle > 90 && angle <= 270 || (angle < -90 && angle >= -270));
            this.wallDimRightTop.setDimensionValue(valueRight, PlanManager.getInstance().getZoomScale());
            this.wallDimRightTop.setFlipped(angle > 90 && angle <= 270 || (angle < -90 && angle >= -270));
        } else {
            if (this.wallDimLeftTop !== null) {
                this.wallDimLeftTop.removeFromParent(true);
                this.wallDimLeftTop = null;
            }
            if (this.wallDimRightTop !== null) {
                this.wallDimRightTop.removeFromParent(true);
                this.wallDimRightTop = null;
            }
        }
    }
    updateDimensions(box: any) {
        //Update visibility
        if (!this._valid) {
            //Hide dimensions for invalid walls
            this.wallDimTop.setVisible(false);
            this.wallDimBot.setVisible(false);

        } else if (this._cuttingWall !== null) {
            this.wallDimTop.setVisible(false);
            this.wallDimBot.setVisible(false);
        } else if (this._isSelected || this._forcedDimensions) {
            //Show both dimensions on wall selected
            this.wallDimBot.setVisible(true);
            this.wallDimTop.setVisible(true);
        } else {
            this.wallDimTop.setVisible(false);
            this.wallDimBot.setVisible(false);
        }
        //Update positions
        var currentZoom = PlanManager.getInstance().getZoomScale();
        var offsetDimension = 1 / currentZoom;
        var angle = this.savaneEntity.getWallAngle(true) * 360.0 / (Math.PI * 2.0);
        this.wallDimTop.setPosition((this.savaneEntity.length + box[0][0] - (this.savaneEntity.length - box[3][0])) / 20,
            (this.dimWall.y * 0.5) + (this.savaneEntity.shiftOffset / 10) + (Utils.DIMENSION_DIST * offsetDimension));
        this.wallDimTop.setDimensionValue(Math.abs(box[0][0] - box[3][0]) / 10, currentZoom);
        this.wallDimBot.setPosition((this.savaneEntity.length + box[1][0] - (this.savaneEntity.length - box[2][0])) / 20,
            (-this.dimWall.y * 0.5) + (this.savaneEntity.shiftOffset / 10) - (Utils.DIMENSION_DIST * offsetDimension));
        this.wallDimBot.setDimensionValue(Math.abs(box[1][0] - box[2][0]) / 10, currentZoom);
        this.wallDimBot.setFlipped(angle > 90 && angle <= 270 || (angle < -90 && angle >= -270));
        this.wallDimTop.setFlipped(angle > 90 && angle <= 270);

    }
    /**
     * Update node display and values
     * @param wallEntity
     */
    calculateNeighboorWallValues(wallEntity: Wall) {
        var walls = wallManager.getWallsAtPosition(wallEntity.begin, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance, -1);

        if (walls !== null) {
            for (var i = 0; i < walls.length; i++) {
                var node = EntityManager.getInstance().getNode(walls[i]);

                if (node !== null) {
                    node.needRedraw = true;
                }
            }
        }

        walls = wallManager.getWallsAtPosition(wallEntity.end, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance, -1);

        if (walls !== null) {
            for (i = 0; i < walls.length; i++) {
                var node = EntityManager.getInstance().getNode(walls[i]);

                if (node !== null) {
                    node.needRedraw = true;
                }
            }
        }
    }
    /**
     * Load and return shader program
     * @returns {*}
     */

    setDimWall(length: number, thickness: number) {
        this.dimWall.x = length;
        this.dimWall.y = thickness;
    }

    setSelected(value: boolean) {
        if (this._isSelected !== value) {
            this.needRedraw = true;
        }

        super.setSelected(value);
        //this._selected = value;
        this.calculateNeighboorWallValues(this.wallEntity);
    }

    /**
    * Hover node
    **/
    setHovered(value: boolean) {
        if (this._isHovered !== value) {
            this.needRedraw = true;
        }

        super.setHovered(value);
    }

    setValidity(value: boolean) {
        if (this._valid !== value) {
            this.needRedraw = true;
        }

        this._valid = value;
    }

    isValid(): boolean {
        return this._valid;
    }
    setForcedDimensions(value: boolean) {
        this._forcedDimensions = value;
    }

    setCuttingWall(cuttingWall: boolean) {
        this._cuttingWall = cuttingWall;
    }

    //Prevent update
    update(dt: any  = null) {
        if (this.needRedraw || this._isSelected || this._isHovered || !this._valid) {
            //FIXME for now wall don't use default update
            super.update(dt);
            //Carefull return the global boundingBoxCut
            var box = this.savaneEntity.boundingBoxCut;
            //Draw wall polys
            this.drawWall(box);
            //Update layer for dimensions
            this.updateDimensions(box);
            //Handle z-index + draw hovered part
            this.drawOverlay();
            if (this._movableUIActive && !this._isHovered) {
                this.exitMovable();
            }
            this.needRedraw = false;
        }
    }

    /**
     * Create dimensions nodes
     */
    createWallDimension() {
        this.wallDimTop = new DimensionNode();
        this.wallDimTop.setPosition(this.savaneEntity.length / 20, (this.dimWall.y * 0.5) + (this.savaneEntity.shiftOffset / 10) + Utils.DIMENSION_DIST);
        this.wallDimTop.setName('wallDimTop');
        this.wallDimTop.setTag(this.wallId);
        this.addChild(this.wallDimTop, 1);
        this.wallDimBot = new DimensionNode();
        this.wallDimBot.setPosition(this.savaneEntity.length / 20, (-this.dimWall.y * 0.5) + (this.savaneEntity.shiftOffset / 10) - Utils.DIMENSION_DIST);
        this.wallDimBot.setName('wallDimBot');
        this.wallDimBot.setTag(this.wallId, 1);
        this.addChild(this.wallDimBot);
    }
    enterMovable(cursorPosition: number[], zoom: number, isPointHover: boolean) {
        // If in decoration state, then let's not display moveable icon over the element
        if (PlanManager.getInstance().getAction() === ActionStateEnum.idleDecoration) {
            return;
        }
        if (this._isSelected) {
            return;
        }
        var alreadyHover = this._isHovered;
        this._movableUIActive = true;

        var wallEntity = this.wallEntity;

        if (!alreadyHover) {
            // This makes the dimensions flicker around the wall
            //            this.setForcedDimensions(true);
            this.calculateNeighboorWallValues(wallEntity);
        }
        if (!isPointHover) {
            //Create arrows for movable wall
            if (this.topSprite === null) {
                this.topSprite = cc.Sprite.create();
                this.topSprite.initWithSpriteFrameName('plan/wall_hilighted_1.png');
                this.topSprite.setFlippedY(true);
                this.topSprite.setScale(0.7 / zoom);
                this.topSprite.setPosition(0, (this.dimWall.y * 0.8) + (this.savaneEntity.shiftOffset / 10) + Utils.DIMENSION_DIST / zoom);
                this.topSprite.setRotation(90);
                this.addChild(this.topSprite);
            }
            if (this.botSprite === null) {
                this.botSprite = cc.Sprite.create();
                this.botSprite.initWithSpriteFrameName('plan/wall_hilighted_1.png');
                this.botSprite.setScale(0.7 / zoom);
                this.botSprite.setPosition(0, (-this.dimWall.y * 0.8) + (this.savaneEntity.shiftOffset / 10) - Utils.DIMENSION_DIST / zoom);
                this.botSprite.setRotation(-90);
                this.addChild(this.botSprite);
            }
            if (this.middleSprite === null) {
                this.middleSprite = cc.Sprite.create();
                this.middleSprite.initWithSpriteFrameName('plan/wall_hilighted_2.png');
                this.middleSprite.setScale(0.7 / zoom);
                this.middleSprite.setScaleX((this.dimWall.y * 2 * 0.8) + (this.savaneEntity.shiftOffset / 10));
                this.middleSprite.setPosition(0, 0);
                this.middleSprite.setRotation(90);
                this.addChild(this.middleSprite);
            }

            //Update arrow position to cursor position
            var invertMat = math.mat4.create();
            //var wallEntity = wallManager.getWall(this.wallId);
            math.mat4.invert(invertMat, wallEntity.globalMatrix);
            var localPosition = math.vec3.create();
            math.vec3.transformMat4(localPosition, cursorPosition, invertMat);
            //localPosition[0] -= wallEntity.length * 0.5;
            var screenLocalPosition = GameObjectManager.convertToCocosCoord(localPosition);
            if (this.topSprite !== null) {
                this.topSprite.setPositionX(screenLocalPosition.x);
            }
            if (this.botSprite !== null) {
                this.botSprite.setPositionX(screenLocalPosition.x);
            }
            if (this.middleSprite !== null) {
                this.middleSprite.setPositionX(screenLocalPosition.x);
            }
        }
        else {
            if (this.topSprite !== null) {
                this.removeChild(this.topSprite);
                this.topSprite = null;
            }
            if (this.botSprite !== null) {
                this.removeChild(this.botSprite);
                this.botSprite = null;
            }
            if (this.middleSprite !== null) {
                this.removeChild(this.middleSprite);
                this.middleSprite = null;
            }
        }

    }
    exitMovable() {
        var i;
        /*if (this._isSelected) {
            return;
        }*/
        var wallEntity = this.wallEntity;
        this._movableUIActive = false;

        this.setForcedDimensions(false);
        this.calculateNeighboorWallValues(wallEntity);
        var wallsBegin = wallManager.getWallsAtCorner(wallEntity.begin, wallEntity.floor, SavaneConstants.PositionTolerance);
        var wallsEnd = wallManager.getWallsAtCorner(wallEntity.end, wallEntity.floor, SavaneConstants.PositionTolerance);
        var wallNode;
        if (wallsBegin) {
            for (i = 0; i < wallsBegin.length; i++) {
                wallNode = EntityManager.getInstance().getNode(wallsBegin[i]);
                if (wallNode !== null) {
                    wallNode.setForcedDimensions(false);
                    wallNode.calculateNeighboorWallValues(wallsBegin[i]);
                }
            }
        }
        if (wallsEnd) {
            for (i = 0; i < wallsEnd.length; i++) {
                wallNode = EntityManager.getInstance().getNode(wallsEnd[i]);
                if (wallNode !== null) {
                    wallNode.setForcedDimensions(false);
                    wallNode.calculateNeighboorWallValues(wallsEnd[i]);
                }
            }
        }
        if (this.topSprite !== null) {
            this.removeChild(this.topSprite);
            this.topSprite = null;
        }
        if (this.botSprite !== null) {
            this.removeChild(this.botSprite);
            this.botSprite = null;
        }
        if (this.middleSprite !== null) {
            this.removeChild(this.middleSprite);
            this.middleSprite = null;
        }
    }

    startVisualiseMode(_wallEntity: Wall) {
        this.setForcedDimensions(true);
    }
    endVisualiseMode(_wallEntity: Wall) {
        this.setForcedDimensions(false);
    }
    removeListeners() {
        eventsManager.instance.removeListener(this.coteListener);
        eventsManager.instance.removeListener(this.dotListener);
        eventsManager.instance.removeListener(this.scrollListener);
        eventsManager.instance.removeListener(this.highligthListener);
        eventsManager.instance.removeListener(this.planListener);
        eventsManager.instance.removeListener(this.arrOnWallListener);
        eventsManager.instance.removeListener(this.setWallTransparency);
    }
    onEnter() {
        super.onEnter();
        this.planListener = eventsManager.instance.addListener(Events.PLAN_STATE_CHANGED, (_event: any) => {
            var state = PlanManager.getInstance().getAction();
            if (state === ActionStateEnum.idleDecoration) {
                this.calculateNeighboorWallValues(this.wallEntity);
            }
        })
        this.scrollListener = eventsManager.instance.addListener(Events.ZOOM_SCROLLWIN_CHANGED, (event: any) => {
            if (this.topSprite !== null) {
                this.topSprite.setScale(0.7 / event.getUserData());
                this.topSprite.setPositionY((this.dimWall.y * 0.8) + (this.savaneEntity.shiftOffset / 10) + Utils.DIMENSION_DIST / event.getUserData());
            }
            if (this.botSprite !== null) {
                this.botSprite.setScale(0.7 / event.getUserData());
                this.botSprite.setPositionY((-this.dimWall.y * 0.8) + (this.savaneEntity.shiftOffset / 10) - Utils.DIMENSION_DIST / event.getUserData());
            }
            if (this.middleSprite !== null) {
                this.middleSprite.setScale(0.7 / event.getUserData());
                this.middleSprite.setScaleX((this.dimWall.y * 2 * 0.8) + (this.savaneEntity.shiftOffset / 10));
            }

            this.needRedraw = true;
        });
        this.dotListener = eventsManager.instance.addListener(Events.TOGGLE_WALL_DOTS, (event: any) => {
            this.dotVisible = event.getUserData();
            this.needRedraw = true;
            var wall = this.wallEntity;
            if (wall === null)
                return;
        });
        this.coteListener = eventsManager.instance.addListener(Events.HIDE_DIMENSION_PRESSED, (event: any) => {
            this._showDimensionChecked = event.getUserData();
            var wall = this.wallEntity;
            if (wall === null)
                return;
        });
        this.highligthListener = eventsManager.instance.addListener(Events.TOGGLE_HIGHLIGHT_MODE, (_event: any) => {
            var wall = this.wallEntity;
            if (wall === null)
                return;
        });
    }
    onExit() {
        super.onExit();
        this.removeListeners();
    }

    setTempCoating(directColor: any, undirectColor: any) {
        this.needRedraw = true;
        this.tempCoatingDirect = directColor;
        this.tempCoatingUndirect = undirectColor;
    }
}
